import URLParamService from "./URLParamService";

const queryParams = URLParamService.getQueryParams();
const apiKey = queryParams.apiKey;
const hash = queryParams.hash;
const ts = queryParams.ts;
const token = queryParams.token;

const getApiKey = (): string => {
  if (queryParams.hasOwnProperty("apiKey") && apiKey?.length > 0) {
    return apiKey;
  }
  return "";
};

const getHash = (): string => {
  if (queryParams.hasOwnProperty("hash") && hash?.length > 0) {
    return hash;
  }
  return "";
};

const getTs = (): number => {
  if (queryParams.hasOwnProperty("ts") && ts) {
    return ts;
  }
  return Math.floor(new Date().getTime() / 1000);
};

const getToken = (): string => {
  if (queryParams.hasOwnProperty("token") && token?.length > 0) {
    return token;
  }
  return "";
};

const AuthService = {
  getApiKey,
  getHash,
  getTs,
  getToken,
};

export default AuthService;
